import React from 'react';
import { BoxParams } from './Box';

export type GameOverParams = {
  wordNumber: number;
  win: boolean;
  correctWord: string;
  tries: Array<Array<BoxParams>>;
};

const getEmoji = (answer:string | undefined) => {
  switch(answer){
    case 'NO':
      return '⬜';
    case 'PERFECT':
      return '🟩';
    case 'WRONG_POS':
      return '🟨';
  }
  return '';
}

const GameOver = ({win, correctWord, tries, wordNumber}:GameOverParams) => {
  const [open, setOpen] = React.useState(true);
  const [hasCopiedResult, setHasCopiedResult] = React.useState(false);
  const supportsShare = navigator.share !== undefined;

  const copyResults = (content:string) => {
    console.log(content)

    navigator.clipboard.writeText(content).then(function() {
      console.log("copied!");
      setHasCopiedResult(true)
    })
  }

  const shareResults = (content:string) => {
    console.log(content)

    if(supportsShare) {
      navigator.share({
        text: content,
      })
    }
  }

  const classNames = ['GameOver'];
  if(win) {
    classNames.push('win')
  } else {
    classNames.push('fail')
  }

  if(!open) {
    return null
  }

  const shareStr = `Sanari #${wordNumber} ${tries.length} / 6\n` + tries.map(item => {
    return item.map(a => getEmoji(a.answer)).join('')
  }).join('\n');

  const shareMarkup = tries.map((item, rowIndex) => {
    return (
      <div className="emojiRow" key={rowIndex}>
        {item.map((a, index) => <span key={`${a.letter}-${index}`}>{getEmoji(a.answer)}</span>)}
      </div>
    );
  });

  return (
    <div className={classNames.join(' ')}>
      <div className="close" onClick={() => { setOpen(false) }}>✕</div>
      <h2>{win ? 'Oikein!' : 'Peli päättyi'}</h2>
      <h3>Sana oli "{correctWord}"</h3>
      <br/>
      <div style={{ display: 'flex', flexDirection: 'column' }}>{shareMarkup}</div>
      <div className="ShareBlock">
        <div>{hasCopiedResult && <span>Kopioitu!</span>}</div>
        <button className="ShareButton" onClick={() => copyResults(shareStr)}>
          Kopioi
        </button>
        {supportsShare && (
          <button className="CopyButton" onClick={() => shareResults(shareStr)}>
            Jaa
          </button>
        )}
      </div>
    </div>
  )
}

export default GameOver;
